import { useQuery } from '@tanstack/react-query'
import { QUERY_TIME_CONFIG } from '@omnea-app/fe-api-client/queryConfig'
import { LoginApiClient } from '@omnea-app/login/loginHttpClient'
import { throwIfApiError } from '@omnea-app/packages/universal/error-handling/throwifApiError'
import { useToken } from './TokenProvider'

export const useAvailableOrganisations = () => {
  const { getToken } = useToken()
  return useQuery({
    queryKey: ['available-organisations'],
    staleTime: QUERY_TIME_CONFIG.REFERENCE_DATA_STALE_TIME,
    queryFn: async () => {
      const token = await getToken()
      const loginClient = new LoginApiClient({ authorization: `Bearer ${token}` })
      const { data, error } = await loginClient.GET('/available-organisations')
      throwIfApiError(error)
      return data
    },
  })
}
